export default "__VITE_ASSET__061851d9__"